import { getMacAddress } from '../utils/mac'
// export async function getDeviceList() {
//   const res = await http.get(`http://${getAppConfig('host')}:10011/device`)
//   return get(res, 'data', {});
// }

export function getMac() {
  return getMacAddress()
}